import React from 'react';

import escapeRegExp from './escapeRegExp';

export const markSearchText = (
  Highlight: TAnyComponent,
  text: string,
  search?: string | RegExp,
) => {
  const isSearchString = typeof search === 'string';

  if (!text || !search || (isSearchString && search.trim().length === 0)) {
    return text;
  }
  const result: React.ReactNode[] = [];
  const lowerSearch = isSearchString ? escapeRegExp(search.toLowerCase()) : search;
  const lowerText = text.toLowerCase();
  const recursion = (index: number): React.ReactNode[] => {
    const match = lowerText.substring(index).match(lowerSearch);

    if (match === null || match.index === undefined) {
      result.push(text.substring(index));

      return result;
    }
    const startIndex = index + match.index;
    const searchText = text.substring(startIndex, startIndex + match[0].length);

    result.push(text.substring(index, startIndex));
    result.push(<Highlight key={index}>{searchText}</Highlight>);

    return recursion(startIndex + searchText.length);
  };

  return recursion(0);
};

export default markSearchText;
